import {
  HandPlatter,
  Palmtree,
  Store,
  Umbrella,
  Landmark,
  Heart,
  Building2,
  Gift,
  Briefcase,
  MoreHorizontal,
  Building,
  Clock,
  BookUser
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import CategoryCard from "./CategoryCard";
import Insurance from "./assests/Insurance.png";
import Retail from "./assests/Retail.png";
import FinancialServices from "./assests/FinancialServices.png";
import Education from "./assests/Education.png";
import RealEstate from "./assests/RealEstate.png";
import Health from "./assests/Health.png";
import HomeServices from "./assests/HomeServices.png";
import Categories2 from "./categories2";
import TalkToAgentCards from "./TalkToAgent";
// import Header from "./assests/Header.png";
import Footer from "./footer";
import Header from "./Header";

const cardData = [
  {
    id: 1, // Insurance
    image: Insurance,
    headText: "Insurance",
    subText: (
      <>
        Simplify policy sales, renewals, and <br />
        claims with quick qualification and <br />
        instant policy details.
      </>
    )
  },
  {
    id: 2, // Retail
    image: Retail,
    headText: "Retail",
    subText: (
      <>
        Support the full retail journey—track and return orders,
        <br />
        place F&B orders, schedule repairs, manage rewards, and assist vendors.
      </>
    )
  },
  {
    id: 3, // Financial Services
    image: FinancialServices,
    headText: "Financial Services",
    subText: (
      <>
        Qualify leads, re-engage prospects, <br />
        and manage loans, mortgages, EMI <br />
        reminders, and collections effortlessly.
      </>
    )
  },
  {
    id: 4, // Education
    image: Education,
    headText: "Education",
    subText: (
      <>
        Qualify student leads and simplify <br />
        admissions. Provide instant answers <br />
        to course and enrollment FAQs.
      </>
    )
  },
  {
    id: 5, // Real Estate
    image: RealEstate,
    headText: "Real Estate",
    subText: (
      <>
        Qualify buyer leads, arrange property viewings,
        <br />
        and guide users through mortgage assistance in one seamless flow.
      </>
    )
  },
  {
    id: 6, // Health & Fitness
    image: Health,
    headText: "Health & Fitness",
    subText: (
      <>
        Book or reschedule clinic and fitness <br />
        appointments, answer FAQs, and qualify <br />
        leads to boost member engagement.
      </>
    )
  },
  {
    id: 7, // Home Services
    image: HomeServices,
    headText: "Home Services",
    subText: (
      <>
        Easily schedule and confirm HVAC <br />
        repairs or other home service <br />
        appointments without calls or delays.
      </>
    )
  }
];

export default function Categories() {
  const navigate = useNavigate();

  const handleCategoryClick = (categoryId: number) => {
    // Navigate to agents page with category parameter
    navigate(`/agents?category=${categoryId}`);
  };

  return (
    <div>
      <div className="bg-white">
        <Header />
        <div className="mt-8 mb-24 flex items-center justify-center">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {cardData.map((card, index) => (
              <CategoryCard
                key={index}
                image={card.image}
                headText={card.headText}
                subText={card.subText}
                categoryId={card.id}
                onCategoryClick={handleCategoryClick}
              />
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
